import { APIClient } from "../api";
import axios, { AxiosAdapter } from 'axios';
export default class ServiceGroupService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async getByUserId(userId: number, areaId: number, customerId: number) {
        if (userId === 0) {
            return { data: [] };
        }
        if (areaId === 0) {
            return { data: [] };
        }
        if (customerId === 0) {
            return { data: [] };
        }
        const url = this.endpoint + `/ServiceGroup/User/${userId}/${areaId}/${customerId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetServicoViewFastServiceTreeTag(userId: number, search: string, customerId: number) {
        if (userId === 0) {
            return { data: [] };
        }
        const url = this.endpoint + `/ServiceGroup/ViewFastServiceTreeByTag/${userId}/${search}/${customerId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetClassificationViewTreeTag(userId: number, search: string, customerId: number) {
        if (userId === 0) {
            return { data: [] };
        }
        const url = this.endpoint + `/ServiceGroup/GetClassificationViewTreeTag/${userId}/${search}/${customerId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetUserAttendantFilter(userId: any, customerIdList?: string) {
        if (userId === 0) {
            return { data: [] };
        }
        const url = this.endpoint + `/ServiceGroup/UserAttendantFilter/${userId}?customerId=${customerIdList}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetByManager(userId: number) {
        const url = this.endpoint + `/ServiceGroup/ManagerFilter/${userId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetByCustomer(customerId: number) {
        const url = `${this.endpoint}/ServiceGroup/GetByCustomer/${customerId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getByUserAttendantId(userId: number, areaId: number, customerId: number) {
        const url = this.endpoint + `/ServiceGroup/UserAttendant/${userId}/${areaId}/${customerId}`;

        if (typeof this.cancelToken != typeof undefined) {
            this.cancelToken.cancel("Operation canceled due to new request.")
        }

        //Save the cancel token for the current request
        this.cancelToken = axios.CancelToken.source();
        return this.api({
            method: 'get',
            url,
            cancelToken: this.cancelToken.token
        });
    }
}